const ja = {
    '/': {
        title: '{brand} | スポーツベッティング、ライブカジノ & 即時出金',
        description: '{brand}でスロット、ライブカジノを楽しみ、スポーツに賭けましょう。即時出金、証明可能なフェアゲーム & 24時間サポートのクリプトカジノ。'
    },
    '/casino': {
        title: 'オンラインカジノ | スロット、ブラックジャック & ライブディーラー | {brand}',
        description: '{brand}でスロット、ブラックジャック、ルーレット & ライブディーラーを楽しめます。数百のゲーム、高速クリプト入金 & 24時間いつでも即時出金。'
    },
    '/sports': {
        title: 'オンラインスポーツベッティング | クリプトスポーツベット & オッズ | {brand}',
        description: '{brand}でスポーツに賭けましょう。サッカー、バスケットボールなどの競争力あるオッズ。ライブベッティング、安全なクリプト賭け & 迅速な支払い。'
    },
    '/livecasino': {
        title: 'ライブカジノ | ブラックジャック、ルーレット & ライブディーラー | {brand}',
        description: '{brand}でブラックジャック、ルーレット & ライブカジノゲームを楽しめます。本物のディーラー、HDストリーミング & 24時間豊富なライブテーブル。'
    },
    '/slots': {
        title: 'オンラインスロット | 豊富なカジノスロット | {brand}',
        description: '{brand}で膨大なスロットコレクションを回しましょう。クラシックフルーツマシン、ビデオスロット & プログレッシブ – すべてクリプトでプレイ可能。'
    },
    '/vip': {
        title: 'VIPプログラム | 限定リワード & 特典 | {brand}',
        description: '{brand}のVIPプログラム：限定ボーナス、パーソナライズ特典、優先サポート。アクティブなプレイヤー向けの特別な恩恵。'
    },
    '/welcome-offer': {
        title: 'ウェルカムオファー | クリプトカジノ | {brand}',
        description: '{brand}のウェルカムオファーをご確認ください。クリプトで始めて、新規プレイヤー限定の特典をお楽しみください。'
    },
    '/referral': {
        title: '紹介プログラム | リワードを獲得 | {brand}',
        description: '友達を{brand}に招待して、参加・条件達成時にリワードを獲得しましょう。紹介リンクをシェアして稼ぎ始めよう。'
    },
    '/promotion-page': {
        title: 'プロモーション | ボーナス & 特別オファー | {brand}',
        description: '{brand}の全プロモーションをご覧ください。クリプトプレイヤー向けのボーナス、フリースピン、特別オファー。'
    },
    '/hotslots': {
        title: '人気スロット | 話題のカジノスロット | {brand}',
        description: '{brand}で最も人気のスロットゲームをプレイ。ホットなスロットをクリプトで楽しもう。'
    },
    '/newgames': {
        title: '新着ゲーム | 最新カジノゲーム | {brand}',
        description: '{brand}で最新のカジノゲームをチェック。スロット、ライブゲーム、テーブルゲームの新作が続々登場。'
    },
    '/populargames': {
        title: '人気ゲーム | 人気カジノゲーム | {brand}',
        description: '{brand}で最も人気の高いカジノゲームをお楽しみください。スロットからライブゲームまで幅広くご用意。'
    },
    '/gameshows': {
        title: 'ゲームショー | ライブゲームショーカジノ | {brand}',
        description: '{brand}でライブゲームショーをお楽しみください。本物の司会者とユニークなゲームで大勝ちを目指そう。'
    },
    '/table_games': {
        title: 'テーブルゲーム | ブラックジャック、ルーレット & バカラ | {brand}',
        description: '{brand}でブラックジャック、ルーレット、バカラなどのテーブルゲームをお楽しみください。クリプトでプレイ可能。'
    },
    '/hotlive': {
        title: '人気ライブカジノ | 注目のライブカジノゲーム | {brand}',
        description: '{brand}で最も人気の高いライブカジノゲームをお楽しみください。本物のディーラーとリアルタイムで対戦。'
    },
    '/featurebuyin': {
        title: 'ボーナス購入スロット | フィーチャーバイイン | {brand}',
        description: '{brand}でボーナス購入機能付きスロットをプレイ。待たずにボーナスラウンドへ直接アクセス。'
    }
};
export default ja;
